import { FC } from "react"

import If from "../../../../if"
import Tooltip from "../../../../tool-tip"
import Badge from "../../../../badge"

interface Props {
  className?: string
  dashboardPageviewCount: number
  rateAlertEmailOpenCount: number
  smsAllowed: number
  smsFollowupSent?: "0" | "1"
}

const EngagementsEvents: FC<Props> = ({
  className,
  dashboardPageviewCount,
  rateAlertEmailOpenCount,
  smsAllowed,
  smsFollowupSent
}) => {
  const isSMSSent = !!smsAllowed && smsFollowupSent === "1"

  const eventCount = dashboardPageviewCount + rateAlertEmailOpenCount

  return (
    <If
      condition={eventCount > 0 || isSMSSent}
      then={
        <>
          <If
            condition={isSMSSent}
            then={
              <Badge.Alt className={`${className} ml-1`}>SMS sent</Badge.Alt>
            }
          />
          <If
            condition={eventCount > 0}
            then={
              <Tooltip
                displayTextClass="justify-self-start ml-1"
                toolTipNode={<span>🔥 {eventCount}+</span>}
                text={
                  <ul className="text-[10px]">
                    <If
                      condition={dashboardPageviewCount > 0}
                      then={
                        <li>
                          <span className="inline-block mr-1 -rotate-90">
                            🧲
                          </span>
                          &nbsp;Dashboard pageview {dashboardPageviewCount}x
                        </li>
                      }
                    />
                    <If
                      condition={rateAlertEmailOpenCount > 0}
                      then={
                        <li>
                          <span className="inline-block mr-1">📧</span>
                          &nbsp;Rate alert opened {rateAlertEmailOpenCount}x
                        </li>
                      }
                    />
                  </ul>
                }
                placement="top"
              />
            }
          />
        </>
      }
    />
  )
}

export default EngagementsEvents
